import { useIntl } from 'react-intl'
import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { errorCode } from 'app/constants/errorCode'

import MessageAlert from 'app/components/MessageAlert'
import { Routes } from 'app/services/routeService/routeService'
import { logoutFrontEnd } from 'app/auth/store/actions'

export const useHealthCheck = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const healtCheck = useMutation({
    mutationFn: async () => {
      const response = await effects.apis.authV2.healtCheck()
      return response
    },
    onError: (error) => {
      const msgError =
        error.response.data.error ??
        formatMessage({ id: 'error.InternalServerError' })
      if (msgError.name === errorCode.SystemMaintenanceError) {
        logoutFrontEnd(dispatch)
        dispatch({
          type: 'DISABLED_MAINTENANCE',
          value: true,
        })
        history.push(Routes.maintenance())
      } else
        dispatch(
          MessageAlert.showError({
            message: msgError,
          }),
        )
    },
  })

  return { healtCheck }
}
